import React, { useState } from 'react'
import { goToHomePage } from '../../helpers/Utils'
import { Card, CardContent } from '../../components/ui/card'
import { IconInfoCircleFilled, IconX } from '@tabler/icons-react'
import { Button } from '../../components/ui/button'
import { useTranslation } from 'react-i18next'

export default function ViewRequestActiveStep4 () {
  const [displayPilotPhaseBanner, setDisplayPilotPhaseBanner] = useState(true)
  const { t } = useTranslation(['viewRequest'])

  return (
    <div className='login-container'>
      <div className='logo' onClick={goToHomePage} />
      <Card className='login-card p-8'>
        <CardContent
          style={{
            backgroundColor: 'white',
            display: 'flex',
            maxWidth: '480px',
            flexDirection: 'column'
          }}
        >
          <div>
            <h2 className='font-weight-700 gp-text24 tracking-0 gp-lh28 gp-mb8'>
              {t('accountCreatedSuccess')}
            </h2>
            <p
              style={{
                fontSize: '0.875rem',
                color: '#555',
                marginBottom: '1.5rem'
              }}
            >
              {t('accountSuccessSubheading')}
            </p>
          </div>
          {displayPilotPhaseBanner && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#E6F4FE',
                padding: '12px',
                borderRadius: '8px'
              }}
            >
              <div
                style={{
                  // backgroundColor: 'red',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <IconInfoCircleFilled height={16} width={16} fill='#0D74CE' />
                  <span
                    style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      lineHeight: '20px',
                      color: '#1C2024'
                    }}
                  >
                    {t('verificationPending')}
                  </span>
                </div>
                <IconX
                  onClick={() => setDisplayPilotPhaseBanner(false)}
                  height={16}
                  width={16}
                  color='#000509E3'
                />
              </div>
              <span
                style={{
                  padding: '8px 24px 0px 24px',
                  fontSize: '12px',
                  fontWeight: '400',
                  lineHeight: '16px',
                  color: '#1C2024'
                }}
              >
                {t('verifyAccountAndActivate')}
              </span>
            </div>
          )}
          <Button
            className='bg-[#6926D9]'
            onClick={goToHomePage}
            style={{
              display: 'flex',
              marginTop: '24px'
            }}
          >
            {t('close')}
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
